import { render, staticRenderFns } from "./Rubrique1.vue?vue&type=template&id=295e1de4&"
import script from "./Rubrique1.vue?vue&type=script&lang=js&"
export * from "./Rubrique1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports